import { API_VERSION } from '@Constants/runtimeConstants';
import { type HttpConfig, type HttpOptionsHandler, useToken } from '@synqo/frontend-component-library';
import { isSynqoUrl } from '@utils/isSynqoUrl';
import { useCallback, useMemo } from 'react';
import { useSynqoApiVersionCheck } from './useSynqoApiVersionCheck';

export function useSynqoHttpConfigOptions(version: string): HttpConfig['options'] {
    const { getToken } = useToken();

    return useCallback<HttpOptionsHandler>(
        async () => ({
            credentials: 'include',
            headers: {
                Accept: `application/x.synqo+json;v=${version}`,
                'Content-Type': `application/x.synqo+json;v=${version}`,
                Authorization: `Bearer ${await getToken()}`,
            },
        }),
        [getToken, version],
    );
}

export function useSynqoHttpConfig(): HttpConfig {
    const getOptions = useSynqoHttpConfigOptions(API_VERSION);
    const onAfterRequest = useSynqoApiVersionCheck();

    return useMemo(
        () => ({
            options: getOptions,
            onValidateUrl: isSynqoUrl,
            onAfterRequest,
        }),
        [getOptions, onAfterRequest],
    );
}
